import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { addProject } from "src/store/project";
import { getMcode } from "src/store/mcode";
import { ValidationMessages } from 'src/components/common/ValidationMessage';
import { resetStateIdele } from 'src/store/project';
import { getClients } from "src/store/client";
import { getUsers } from "src/store/user";
import { insertProjectstaffData, updateProjectStaffData } from "src/store/projectstaff";
import { CopyContext } from 'src/context/CopyContext';
import { updateProject } from "src/store/project";
import { resetSingleProject } from 'src/store/project';

const ProjectConfirm = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const { formData } = location.state || {};
    const authCd = useSelector((state) => state.mcode.data.projectcategory);
    const authRole = useSelector((state) => state.mcode.data.role);
    const user = useSelector((state) => state.user.data);
    const clientName = useSelector((state) => state.client.data);
    const project = useSelector((state) => state.project);
    const [validationMessages, setValidationMessages] = useState([]);
    const { copyFlg } = useContext(CopyContext);

    const clickBackBtn = () => {
        if (formData.id) {
            navigate(`/projectEdit/${formData.id}`, { state: { formData: formData } });
        }
        else {
            navigate("/projectInput", { state: { formData: formData } });
        }
    };

    const clickRegBtn = () => {
        const ProjectData = {
            id: formData.id,
            client_project_id: formData.client_project_id,
            name_abbreviation: formData.name_abbreviation,
            billing_date: formData.billing_date,
            billing_plans_date: formData.billing_plans_date,
            order_price: formData.order_price,
            order_price_tax_rate: formData.order_price_tax_rate,
            order_date: formData.order_date,
            start_date: formData.start_date,
            end_date: formData.end_date,
            detail: formData.detail,
            manager_id: formData.manager_id,
            sub_manager_id: formData.sub_manager_id,
            t_client_id: formData.t_client_id,
            category_cd: formData.category_cd,
            name: formData.name,

        };        // Prepare project staff data for update
        const ProjectStaff = {
            Project_staff_data: formData.Project_staff_data.map((staff) => ({
                t_user_id: parseInt(staff.projectStaffId),
                role_cd: parseInt(staff.staffRoleCd),
                unit_price: parseInt(staff.unitPrice || 0)
            }))
        }

        if (formData.id) {
            (async () => {
                try {
                    const updateRes = await dispatch(updateProject(ProjectData));
                    const payload = updateRes.payload;

                    // Handle server error
                    if (payload?.status === 500) {
                        alert(payload.message);
                        return;
                    }

                    // Handle Redux error
                    if (updateRes.error) {
                        setValidationMessages([updateRes.error.message]);
                        return;
                    }

                    // Handle validation errors
                    if (payload?.errors) {
                        setValidationMessages(Object.values(payload.errors));
                        return;
                    }                    // Check success using match
                    if (updateProject.fulfilled.match(updateRes)) {
                        const id = payload.data.id;

                        const staffRes = await dispatch(updateProjectStaffData({
                            id: id,
                            staffData: ProjectStaff
                        }));

                        const staffPayload = staffRes.payload;

                        if (staffPayload?.status === 500) {
                            alert(staffPayload.message);
                            return;
                        }

                        if (staffRes.error) {
                            setValidationMessages([staffRes.error.message]);
                            return;
                        }

                        if (staffPayload?.errors) {
                            setValidationMessages(Object.values(staffPayload.errors));
                            return;
                        }

                        // If both updates succeeded, navigate
                        navigate(`/projectDetails/${id}`);
                    }
                }
                catch (error) {
                    setValidationMessages([error.message]);
                }
            })();
        }
        else {
            (async () => {
                try {
                    const response = await dispatch(addProject(ProjectData));
                    const payload = response.payload;
                    if (payload.status === 500) {
                        alert(payload.message);
                        return;
                    }
                    if (payload.errors) {
                        setValidationMessages(payload.errors);
                        return;
                    }
                    if (addProject.fulfilled.match(response)) {
                        const projectId = payload.data.id;
                        // Prepare staff data with new project ID
                        const staffData = {
                            Project_staff_data: formData.Project_staff_data.map((staff) => ({
                                t_project_id: projectId, // use the new projectId here!
                                t_user_id: staff.projectStaffId,
                                role_cd: staff.staffRoleCd,
                                unit_price: staff.unitPrice
                            }))
                        };

                        const staffRes = await dispatch(insertProjectstaffData(staffData));
                        const staffPayload = staffRes.payload;

                        if (staffPayload?.status === 500) {
                            alert(staffPayload.message);
                            return;
                        }
                        if (staffPayload?.errors) {
                            setValidationMessages(Object.values(staffPayload.errors));
                            return;
                        }

                        navigate(`/projectDetails/${projectId}`);
                    }
                } catch (error) {
                    setValidationMessages([error.message]);
                }
            })();
        }
    };

    useEffect(() => {
        dispatch(getMcode({ section_cd: 'projectcategory,role' }));
        dispatch(getClients({ name: 'name' }));
        dispatch(getUsers());
    }, []);

    const clickProjectListBtn = () => {
        dispatch(resetSingleProject());
        navigate('/projectList');
    };

    useEffect(() => {
        if (project.status === 'succeeded') {
            resetStateIdele();
        } else {
            setValidationMessages(project.errors);
        }
    }, [project.status, project.errors, resetStateIdele]);

    return (
        <div className="wrapper">
            {validationMessages && validationMessages.length > 0 && (
                <div style={{ background: "#ffe4e2" }}>
                    <ValidationMessages
                        messages={validationMessages}
                        onClose={() => setValidationMessages([])}
                    />
                </div>
            )}
            <section className="container-fluid contents-top">
                <div className="text-right">
                    <button type="button" className="btn btn-default" onClick={clickProjectListBtn}><span
                        className="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>Back to List</button>
                </div>

                <div className="" id='' style={{ width: "100%", maxWidth: 700, display: "flex", flexDirection: "column" }}>
                    {(formData?.id) ? (
                        <h3 className="title-style01">Modify Project Registration</h3>
                    ) : (
                        <h3 className="title-style01">New Project Registration</h3>
                    )}

                    <div className="form-group div-height">
                        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>Client *</label>
                        <div className="col-sm-9">
                            {clientName && clientName.map((client_id) =>
                                formData?.t_client_id === String(client_id.id) ? (
                                    <p key={client_id.id} className=" form-control confirm_style ">
                                        {client_id.name}
                                    </p>
                                ) : null
                            )}
                        </div>
                    </div>

                    {/* <div className="form-group div-height">
                        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>Project Name * </label>
                        <div className="col-sm-9">
                            <p className=" form-control confirm_style ">{formData?.name}</p>
                        </div>
                    </div> */}
                    <div className="form-group div-height">
                        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>
                            Client Project ID *
                        </label>
                        <div className="col-sm-9">
                            <p className=" form-control confirm_style ">
                                {formData?.client_project_id}
                            </p>
                        </div>
                    </div>

                    <div className="form-group div-height">
                        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>
                            Project Name *
                        </label>
                        <div className="col-sm-9 tooltip-container">
                            <p className="form-control confirm_style break-word" title={formData?.name}>
                                {formData?.name.length > 30 ? `${formData?.name.slice(0, 30)}...` : formData?.name}
                            </p>
                            <span className="tooltip">{formData?.name}</span>
                        </div>
                    </div>

                    <div className="form-group div-height">
                        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>
                            Project name (abbreviation)*
                        </label>
                        <div className="col-sm-9 tooltip-container">
                            <p className="form-control confirm_style break-word" title={formData?.name_abbreviation}>
                                {formData?.name_abbreviation.length > 30 ? `${formData?.name_abbreviation.slice(0, 30)}...` : formData?.name_abbreviation}
                            </p>
                            <span className="tooltip">{formData?.name_abbreviation}</span>
                        </div>
                    </div>

                    <div className="form-group div-height">
                        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>Project Details</label>
                        <div className="col-sm-9">
                            <p className=" form-control confirm_style ">{formData?.detail}</p>
                        </div>
                    </div>
                    <div className="form-group div-height">
                        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>Project Category *</label>
                        <div className="col-sm-9">
                            {authCd && authCd.map((category_cd) =>
                                formData?.category_cd === category_cd.cd ? (
                                    <p key={category_cd.cd} className=" form-control confirm_style ">
                                        {category_cd.code_value1}
                                    </p>
                                ) : null
                            )}
                        </div>
                    </div>
                    <div className="form-group div-height">
                        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>Order Date</label>
                        <div className="col-sm-9">
                            <p className=" form-control confirm_style ">{formData?.order_date}</p>
                        </div>
                    </div>
                    <div className="form-group div-height">
                        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>Billing date (scheduled billing date)</label>
                        <div className="col-sm-9 form-inline">
                            <p className=" form-control confirm_style">{formData?.billing_date}</p>
                            {!copyFlg ? (
                                <>
                                    （&nbsp;
                                    <p className=" form-control confirm_style ">
                                        {formData?.billing_plans_date ? formData.billing_plans_date : ""}
                                    </p>
                                    &nbsp;）
                                </>
                            ) : null}
                        </div>
                    </div>
                    <div className="form-group div-height">
                        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>Order amount (excluding tax) *</label>
                        <div className="col-sm-9">
                            <p className=" form-control confirm_style ">{formData?.order_price}</p>
                        </div>
                    </div>
                    <div className="form-group div-height">
                        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>Consumption tax rate * </label>
                        <div className="col-sm-9">
                            <p className=" form-control confirm_style ">
                                {formData?.order_price_tax_rate}
                            </p>
                        </div>
                    </div>
                    <div className="form-group div-height">
                        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>Project duration *</label>
                        <div className="col-sm-9 form-inline">
                            <p className=" form-control confirm_style ">
                                {formData?.start_date ? formData?.start_date : 'N/A'}
                            </p>
                            &nbsp;～&nbsp;
                            <p className=" form-control confirm_style ">
                                {formData?.end_date ? formData?.end_date : 'N/A'}
                            </p>
                        </div>
                    </div>
                    <div className="form-group div-height">
                        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>Project Leader *</label>
                        <div className="col-sm-9">
                            {user && user.map((userItem) =>
                                formData?.manager_id === String(userItem.id) ? (
                                    <p key={userItem.id} className=" form-control confirm_style ">
                                        {userItem.name}
                                    </p>
                                ) : null
                            )}
                        </div>
                    </div>
                    <div className="form-group div-height">
                        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>Project Sub-Leader*</label>
                        <div className="col-sm-9">
                            {user && user.map((userItem) =>
                                formData?.sub_manager_id === String(userItem.id) ? (
                                    <p key={userItem.id} className=" form-control confirm_style ">
                                        {userItem.name}
                                    </p>
                                ) : null
                            )}
                        </div>
                    </div>
                    <div className="form-group div-height">
                        <label className="col-sm-3 control-label" style={{ textAlign: "end", marginTop: 6 }}>
                            Project Staff *
                        </label>
                        <div className="col-sm-9">
                            {formData?.Project_staff_data?.map((staff, index) => (
                                <p key={index} className="form-control confirm_style">
                                    【{staff.staffRoleName}】{staff.projectStaffName}, Unit Price: {staff.unitPrice}
                                </p>
                            ))}
                        </div>
                    </div>


                    <div className="form-group text-center" style={{ marginTop: 60 }}>
                        <button type="button" onClick={clickBackBtn} className="btn btn-default btn-lg jq-re_edit_data" style={{ marginRight: 20 }}>
                            Back
                        </button>
                        <button type="button" onClick={clickRegBtn} className="btn btn-success btn-lg jq-regester_data">
                            {formData?.id ? "Update" : "Register"}
                        </button>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ProjectConfirm;